import { DirectiveOptions } from 'vue';
import { EventBus } from '../helpers/bus';

const onWindowResize = (el: HTMLElement, value: string | number): boolean => {
    if (el.className.indexOf('u-d-none') > -1) {
        return false;
    }
    if (el.offsetHeight > Number(value)) {
        el.classList.add('u-d-none');
    } else {
        el.classList.remove('u-d-none');
    }
    return true;
};

let cb;

const hideIfBigger: DirectiveOptions = {
    bind(el, { value }): void {
        cb = () => {
            if (!onWindowResize(el, value)) {
                EventBus.$off('windowResize', cb);
                EventBus.$off('orientationChange', cb);
            }
        };
        EventBus.$on('windowResize', cb);
        EventBus.$on('orientationChange', cb);
        setTimeout(cb, 150);
    },
    unbind(): void {
        EventBus.$off('windowResize', cb);
        EventBus.$off('orientationChange', cb);
    },
};

export default hideIfBigger;
